<template>
  <!-- 产品管理 -->
  <div class="manage-normal">
    <Breadcrumb></Breadcrumb>
    <el-form
      :model="form"
      ref="form"
      id="form"
      class="form-body"
      label-width="80px"
      style="margin-top: 10px"
    >
      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="产品分类：">
              <TreeSelect
                :props="treeSelectProps"
                :options="productTypeList"
                v-model="form.typeId"
                ref="childSelTree"
                @getValue="getTreeNodeId"
                style="width:100%"
              ></TreeSelect>
            </el-form-item></div
        ></el-col>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="产品名称：">
              <el-input
                size="small"
                v-model="form.proName"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="产品类型：">
              <el-select
                clearable
                v-model="form.productType"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="(value, index) in dictData['product_type']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="创建时间：">
              <el-date-picker
                size="small"
                v-model="dateValue"
                style="width: 100%;"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="生产时长：">
              <el-select
                clearable
                v-model="form.prodDays"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="(value, index) in dictData['prod_days']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="产品状态：">
              <el-select
                clearable
                v-model="form.dzStatus"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="(value, index) in dictData['dz_status']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="产品编号：">
              <el-input
                size="small"
                v-model="form.pId"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="工厂编号：">
              <el-input
                size="small"
                v-model="form.proCode"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="性别：">
              <el-select
                clearable
                v-model="form.sex"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="(value, index) in dictData['sys_user_sex']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="所属国家：" prop="state">
              <el-select
                clearable
                v-model="form.state"
                placeholder="请选择"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="(value, index) in dictData['country_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="生产厂商：" prop="manufacturer">
              <el-select
                clearable
                v-model="form.manufacturer"
                placeholder="请选择"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="(value, index) in dictData['MANUFACTURER']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="8"
          ><div class="grid-content bg-purple" style="text-align:right;">
            <el-button size="small" type="primary" @click="getData"
              >搜索</el-button
            >
            <el-button size="small" @click="resetForm">重置</el-button>
          </div></el-col
        >
      </el-row>
    </el-form>
    <div class="main-div">
      <div style="overflow:hidden;margin: 0 0 8px 0;">
        <div class="left">
          <el-button
            style="float:left;margin-right:12px;"
            type="primary"
            size="small"
            @click="handleCreateProduct"
            >创建产品</el-button
          >
          <el-button
            style="float:left;margin-right:20px;"
            type="primary"
            size="small"
            @click="handleClearCache"
            >刷新缓存</el-button
          >
          <el-upload
            style="float:left;margin-right:20px;"
            class="upload-task"
            action=""
            ref="uploadControl1"
            :http-request="uploadFile1"
            :on-success="(value) => handleUploadSuccess1(value)"
            :show-file-list="false"
            :file-list="fileList1"
            :limit="1"
            size="small"
          >
            <el-button type="primary" size="small">模版导入</el-button>
          </el-upload>
          <el-button
            style="float:left;margin-right:20px;"
            type="primary"
            size="small"
            @click="handleSetClass"
            >批量设置分类</el-button
          >
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <!--表格-->
      <div class="tab-div">
        <el-table
          id="outTable"
          ref="table"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
          :header-cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column width="400px" label="产品信息">
            <template slot-scope="scope">
              <div style="overflow:hidden;">
                <div style="float:left;margin-right:8px;position:relative;">
                  <el-popover
                    placement="right"
                    :width="scope.row.picWidth"
                    trigger="hover"
                    :close-delay="closeDelay"
                  >
                    <img
                      class="img-big"
                      width="200px"
                      height="200px"
                      :src="
                        scope.row.mainList.length > 0
                          ? `${scope.row.mainList[0].picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                          : ''
                      "
                    />
                    <img
                      style="border-radius: 5px;"
                      slot="reference"
                      class="img-big"
                      width="116px"
                      height="116px"
                      :src="
                        scope.row.mainList.length > 0
                          ? `${scope.row.mainList[0].picUrl}?x-oss-process=image/resize,m_fill,h_150,w_150`
                          : ''
                      "
                    />
                  </el-popover>
                  <div class="product-type">
                    {{ scope.row.productType == "01" ? "定制" : "优选" }}
                  </div>
                </div>
                <div style="float:left">
                  <div
                    style="color:#4934b2;cursor: pointer;"
                    :title="scope.row.proName"
                    class="text-ellipsis width-detail"
                    @click="handleJumpProduct(scope.row)"
                  >
                    {{ scope.row.proName }}
                  </div>
                  <div
                    :title="scope.row.pId"
                    class="text-ellipsis width-detail"
                  >
                    产品编号：{{ scope.row.pId }}
                  </div>
                  <div
                    v-if="scope.row.productType === '01'"
                    class="width-detail"
                  >
                    工厂编号：{{ scope.row.proCode }}
                  </div>
                  <div class="width-detail">
                    生产时长：{{ dictMap["prod_days"][scope.row.prodDays] }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="产品分类" align="center">
            <template slot-scope="scope">
              <div v-html="scope.row.typeName"></div>
            </template>
          </el-table-column>
          <el-table-column prop="htmlCode" label="SKU" align="center">
            <template slot-scope="scope">
              <div v-for="(record, index) in scope.row.skuList" :key="index">
                {{ record.properVal.replace(":", "-") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="零售价" align="center">
            <template slot-scope="scope">
              <div v-for="(record, index) in scope.row.skuList" :key="index">
                ￥{{ record.sellPrice }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="60" label="库存" align="center">
            <template slot-scope="scope">
              {{ scope.row.stock }}
            </template>
          </el-table-column>
          <el-table-column width="60" label="排序" align="center">
            <template slot-scope="scope">
              {{ scope.row.sort }}
            </template>
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="状态/时间"
            align="left"
            width="218"
          >
            <template slot-scope="scope">
              <el-row style="text-align:center;">{{
                dictMap["dz_status"][scope.row.dzStatus]
              }}</el-row>
              <el-row>创建时间：{{ scope.row.createTime }}</el-row>
              <el-row>更新时间：{{ scope.row.updateTime }}</el-row>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <div slot-scope="scope">
              <div>
                <el-button
                  type="text"
                  size="mini"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                ><br />
              </div>
              <div>
                <el-button
                  type="text"
                  size="mini"
                  @click="handleClear(scope.row)"
                  >刷新缓存</el-button
                ><br />
              </div>
              <div v-if="scope.row.dzStatus == '01'">
                <el-button
                  type="text"
                  size="mini"
                  @click="handleModifyStatus(scope.row)"
                  >下架产品</el-button
                ><br />
              </div>
              <div
                v-if="scope.row.dzStatus == '02' || scope.row.dzStatus == '03'"
              >
                <el-button
                  type="text"
                  size="mini"
                  @click="handleModifyStatus(scope.row)"
                  >上架产品</el-button
                ><br />
              </div>
            </div>
          </el-table-column>
          <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
        </el-table>
        <pagination
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="getData"
        />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="更改分类"
      :visible.sync="changeClassVisible"
      destroy-on-close
      width="30%"
    >
      <div>
        <el-form
          ref="changeClassForm"
          :model="changeClassForm"
          :rules="changeClassRules"
          label-width="100px"
          size="small"
        >
          <el-form-item label="产品分类：" prop="typeId">
            <TreeSelect
              :props="treeSelectProps"
              :options="productTypeList"
              v-model="changeClassForm.typeId"
              ref="childSelTree"
              style="width: 100%"
              @getValue="getTreeNodeClassId"
            ></TreeSelect>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="changeClassVisible = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="changeClass" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import TreeSelect from '@/components/common/treeSelect';
import { getProductTypeTree } from "@/api/product/type";
import {mapGetters} from 'vuex'
import { getProductList, addProduct, editProduct, cleaCache, uploadGy, setProductCat } from "@/api/customProduct/product"


export default {
    name: "normalGoodsManage",
    components:{
      Breadcrumb,
      TreeSelect
    },
    computed: {
      ...mapGetters(["dictData", "dictMap"]),
    },
    data(){
      return{
        form:{
          pageNum: 1,
          pageSize: 10,
          typeId: '',
          proName: '',
          productType: '',
          beginTime: null,
          endTime: null,
          prodDays: '',
          dzStatus: '',
          pId: '',
          proCode: '',
          sex: '',
          state: '',
          manufacturer: ''
        },
        formClone:{
          pageNum: 1,
          pageSize: 10,
          typeId: '',
          proName: '',
          productType: '',
          beginTime: null,
          endTime: null,
          prodDays: '',
          dzStatus: '',
          pId: '',
          proCode: '',
          sex: '',
          state: '',
          manufacturer: ''
        },
        changeClassVisible: false,
        changeClassForm: {typeId: '',pId: ''},
        changeClassRules: {
          typeId: [
            { required: true, message: "请选择产品分类", trigger: "blur" },
          ],
        },
        typeIdSelect: [],
        total: 0,
        tableData:[],
        productTypeList: [],
        treeSelectProps: {
          value:'typeId',             // ID字段名
          label: 'typeName',         // 显示名称
          children: 'childrenTree'    // 子级字段名
        },
        dateValue: null,
        closeDelay: 0,
        pIds: [],
        fileList1: [],
        multipleSelection : []
      }
    },

    created() {
      this.getCache()
      var pageNum = this.$route.query.pageNum
      var pageSize = this.$route.query.pageSize
      if(pageNum){
        this.form.pageNum = Number(pageNum)
      }
      if(pageSize){
        this.form.pageSize = Number(pageSize)
      }
      this.getProductTypeTree();
      this.getData();
    },
    methods:{
      getData(){
        this.setCache()
        if (this.dateValue!=null){
          this.form.beginTime=this.dateValue[0];
          this.form.endTime=this.dateValue[1];
        }else{
          this.form.beginTime= undefined
          this.form.endTime= undefined
        }
        getProductList(this.form).then((data) => {
            this.tableData = data.rows;
            this.total = data.total;
            this.pIds = []
            data.rows.map((record)=>{
              this.pIds.push(record.pId)
            })
          });
      },
      handleSetClass(){
        if(this.multipleSelection.length == 0){
          this.msgError('请选择产品')
          return
        }
        this.changeClassVisible = true
      },
      handleJumpProduct(row){
        let routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { pId: row.pId },
        })
        window.open(routeUrl.href, "_blank")
      },
       handleUploadSuccess1(response) {
      this.$refs.uploadControl1.clearFiles()
    },
      resetForm(){
        this.dateValue = undefined
        this.form = this._.clone(this.formClone)
      },
      async getProductTypeTree() {
        let result = await getProductTypeTree();
        this.productTypeList = result.data;
      },
        /**更改分类 */
      changeClass() {
      let _self = this
      this.$refs["changeClassForm"].validate(async (valid) => {
        if (valid) {
          let array = []
          for(let record of this.multipleSelection){
            array.push({ pId: record.pId, typeId: _self.changeClassForm.typeId})
          }
          await setProductCat(array)
          _self.$message.success("修改成功")
          _self.getData()
          _self.changeClassVisible = false
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
      getTreeNodeId(value){
        this.form.typeId = value
      },
      getTreeNodeClassId(value){
        this.changeClassForm.typeId = value
      },
      handleCreateProduct(){
        this.$router.push({path:"/product_mng/manage/createGoods",query:{}})
      },
      handleSelectionChange(val){this.multipleSelection = val},
      handleEdit(row){
        this.$router.push({path:"/product_mng/manage/createGoods",query:{pId: row.pId, pageSize: this.form.pageSize, pageNum: this.form.pageNum}})
      },
       beforeUpload(file) {

    },
       async uploadFile1(file) {
      this.startLoading()
      let formData = new FormData()
      formData.append("file", file.file)
      uploadGy(formData).then((response) => {
        if (response.code === 200) {
          this.msgSuccess("导入成功")
          this.getData()
          this.endLoading()
        } else {
          this.msgError(response.msg)
          this.endLoading()
        }
      }).catch(()=>{
        this.endLoading()
      })
    },
      async handleModifyStatus(row){
        try {
          await editProduct({
            pId: row.pId,
            dzStatus: row.dzStatus === '01' ? '02' : '01'
          })
          this.msgSuccess(`${row.dzStatus === '01' ? '下架' : '上架'}成功`)
          this.getData()
        } catch (error) {
        }
      },

      async handleClear(row){
          try {
          await cleaCache(row.pId)
          this.msgSuccess(`刷新成功`)
          this.getData()
        } catch (error) {
        }
      },
      async handleClearCache(){
         try {
          await cleaCache(this.pIds.join(','))
          this.msgSuccess(`刷新成功`)
          this.getData()
        } catch (error) {
      }

    },
  }
}
</script>
<style scoped>
.main-div {
  background: #ffffff;
  padding: 16px;
  margin: 0 0 12px 0;
  border: 1px solid rgb(221, 221, 221);
}
.width-detail {
  width: 246px;
}
.left {
  float: left;
}
.right {
  float: right;
}
.product-tag {
  display: inline-block;
  font-size: 12px;
  padding: 2px 6px;
  background: #4934b2;
  border-radius: 5px;
  color: #ffffff;
}
.product-type {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: rgb(255, 144, 0);
  background-color: rgb(255, 144, 0);
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
</style>
